import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { OutboundLink } from "gatsby-plugin-google-analytics"

const getData = graphql`
  {
    info: site {
      siteMetadata {
        contact
      }
    }
  }
`

const ResponsibleGamingPage = () => (
  <StaticQuery
    query={getData}
    render={data => {
      const contact = data.info.siteMetadata.contact
      return (
        <Layout>
          <SEO
            title="Responsible Gaming"
            description="Responsible gaming guidance for 918Kiss players: 18+ only, setting spending and time limits, never chasing losses, and where to find free help."
            pagePath="/responsible-gaming/"
          />
          <div className="container">
            <div className="row">
              <div className="col-12 pt-4 appbox-copy px-3 pb-3 mb-2">
                <h1 className="h3 block-title">Responsible Gaming</h1>
                <p>
                  918Kiss is a real-money games app for adults aged 18 or older
                  only. Gambling should always be a form of entertainment, not a
                  way to earn money or to recover money you have lost.
                </p>
                <h2 className="h5 block-title">18+ only</h2>
                <p>
                  918Kiss is intended for people aged 18 or older. If you are
                  under 18, do not use the 918Kiss app and do not use this site
                  to download it.
                </p>
                <h2 className="h5 block-title">
                  Set your limits before you play
                </h2>
                <p>
                  Decide in advance how much money and how much time you are
                  willing to spend, and treat both as strict limits. Only wager
                  money you can afford to lose completely &mdash; money set
                  aside for rent, bills, or other obligations should never be
                  used for gambling. Use the deposit and time-limit options
                  inside the app wherever they are available.
                </p>
                <h2 className="h5 block-title">Never chase losses</h2>
                <p>
                  After a losing session, stop. Trying to win back money you
                  have lost is the fastest way to turn entertainment into a
                  problem. If you find yourself thinking about gambling all day,
                  playing with more than you planned, or feeling that you cannot
                  stop, that is a sign to step away.
                </p>
                <h2 className="h5 block-title">
                  Taking a break and self-exclusion
                </h2>
                <p>
                  If you need a short break, log out and close the app. If you
                  want a longer break, delete the app from your device and do
                  not reinstall it until you are ready. If you feel you have
                  lost control of your gambling, treat it seriously and seek
                  help now &mdash; stepping away on your own is a first step,
                  not a cure.
                </p>
                <h2 className="h5 block-title">Where to get help</h2>
                <p>
                  We do not operate a gambling support hotline. A free,
                  independent online resource with tools and help in many
                  languages is{" "}
                  <OutboundLink
                    href="https://gamblingtherapy.org"
                    className="link"
                  >
                    Gambling Therapy
                  </OutboundLink>
                  . If you are unsure whether your gambling is becoming a
                  problem, use the free self-assessments published by
                  responsible-gaming organisations, and message us on{" "}
                  <OutboundLink href={contact} className="link">
                    WhatsApp
                  </OutboundLink>{" "}
                  if you need help with the app itself.
                </p>
                <p className="pb-2 small">
                  <Link to="/">Back to home</Link>
                  {` · `}
                  <Link to="/terms/">Terms of Use</Link>
                  {` · `}
                  <Link to="/privacy/">Privacy Policy</Link>
                </p>
              </div>
            </div>
          </div>
        </Layout>
      )
    }}
  />
)

export default ResponsibleGamingPage
